import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = '';

export const teamSlugSlice = createSlice({
  name: 'teamSlug',
  initialState,
  reducers: {
    setTeamSlug: (state, { payload: data }) => {
      return data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTeamSlug } = teamSlugSlice.actions;

export const getTeamSlug = (state: RootState) => state.teamSlug;


export default teamSlugSlice.reducer;
